import React from 'react';
import {treeBuild} from './Tree';
import {connect} from 'react-redux';
import CategoryMatchingFrom from './CategoryMatchingFrom';
import CategoryMatchingTo from './CategoryMatchingTo';
import * as api from './../actions/apiCategoryMaching';


export class CategoryMatching extends React.Component{
	constructor(props){
		super(props);
		this.changeCatalogName = this.changeCatalogName.bind(this);
		this.selectedItemFrom = this.selectedItemFrom.bind(this);
		this.clickItemTo = this.clickItemTo.bind(this);
		this.removeMatch = this.removeMatch.bind(this);
		this.state = {
			selected_item_form: null,
			catalog_name: ''
		};
	}

	changeCatalogName(e){
		let val = e.target.value;
		this.setState({
			catalog_name: val
		});
		this.props.dispatch(api.getTrees(val));
	}

	selectedItemFrom(item = null){
		if(item) {
			this.setState({
				selected_item_form: item
			});
		}
		return this.state.selected_item_form;
	}

	clickItemTo(key){
		if(!this.state.selected_item_form){
			alert('Сначала выберете категорию источника');
			return;
		}
		this.props.dispatch(api.categoryMatchingCreate(this.state.selected_item_form, key, this.state.catalog_name));
		this.setState({
			selected_item_form: null
		});
	}

	removeMatch(match_id){
		this.props.dispatch(api.categoryMatchRemove(match_id));
	}

	render(){
		return (
			<div className='row'>
				<div className="col-md-12">
					<div className="input-group">
							<select className="form-control"  onChange={this.changeCatalogName} value={this.state.catalog_name}>
								<option value=""> </option>
								{this.props.catalog_names.map(category_name => {
									return (<option key={category_name} value={category_name}>{category_name}</option>);
								})}
							</select>
					</div>

				</div>
				<div className="col-md-6">
					<CategoryMatchingFrom {...this.props.match_categories_tree} selectedItem={this.selectedItemFrom} removeMatch={this.removeMatch}/>
				</div>
				<div className="col-md-6">
					<CategoryMatchingTo {...this.props.end_categories_tree}  onClick={this.clickItemTo}/>
				</div>
			</div>
		)
	}
}

const CategoryMachingConnect = (store) => {
	let end_categories_tree = treeBuild(store.category_matching.end_categories);
	let match_categories_tree = treeBuild(store.category_matching.matching_categories);
	return {
		end_categories_tree,
		match_categories_tree,
		catalog_names: store.category_matching.catalog_names
	};
};

const CategoryMatchingContainer =  connect(CategoryMachingConnect)(CategoryMatching);
export default CategoryMatchingContainer;



// WEBPACK FOOTER //
// ./frontend/components/CategoryMatching.js